import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { IForBankFormSubSections } from 'components/BusinessToolForm/Sections/forBankSections';

import { CompanyDescriptionExecSummary } from './CompanyDescriptionExecSummary';
import { FinancialInformationExecSummary } from './FinancialInformationExecSummary';
import { FinancialNeedsExecSummary } from './FinancialNeedsExecSummary';
import { GoalsExecSummary } from './GoalsExecSummary';
import { MarketExecSummary } from './MarketExecSummary';
import { ProductsExecSummary } from './ProductsExecSummary';
import { RisksExecSummary } from './RisksExecSummary';
import { TeamExecSummary } from './TeamExecSummary';

const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.GOALS_AND_OBJECTIVES]: GoalsExecSummary,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.COMPANY_DESCRIPTION]: CompanyDescriptionExecSummary,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES]: ProductsExecSummary,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.MARKET_AND_CUSTOMERS]: MarketExecSummary,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.ORGANIZATION_AND_TEAM]: TeamExecSummary,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCIAL_INFORMATION]: FinancialInformationExecSummary,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCING_NEEDS]: FinancialNeedsExecSummary,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.RISKS]: RisksExecSummary,
};

export const ExecutiveSummary: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
